import { FeatureFlagKeys } from './featureFlagKeys';
import { useEvaluatedFeatureFlagsQuery } from './useEvaluatedFeatureFlagsQuery';

export function useFeatureFlag(key: FeatureFlagKeys, defaultValue: boolean): boolean {
    const { data } = useEvaluatedFeatureFlagsQuery();

    if (data === undefined) {
        return defaultValue;
    }

    const value = data[key];
    return typeof value === 'boolean' ? value : defaultValue;
}
